import * as styles from './index.css';

import Spinner from '@nrdy-marketing-engine/spinner/src/spinner';
import useDomTracking from '@nrdy-marketing-engine/tracking/src/use-dom-tracking';
import clsx from 'clsx';

interface PanelButtonProps {
  className?: string;
  isContinueButton?: boolean;
  loading?: boolean;
  onClick: () => void;
  text?: string;
}

export default function PanelButton({
  className,
  isContinueButton,
  loading,
  onClick,
  text,
}: PanelButtonProps) {
  const clickTrackable = useDomTracking('click');
  const transitionClasses = loading ? 'opacity-0 duration-500 transition-opacity' : 'opacity-100';

  const buttonElement = (
    <button
      className={clsx(className, !isContinueButton && styles.fullWidth)}
      onClick={onClick}
      ref={isContinueButton ? clickTrackable : undefined}
    >
      <span className={clsx(transitionClasses, styles.button)}>{text}</span>
      {loading && <Spinner className="absolute left-1/2 top-1/2 -ml-3 -mt-3" />}
    </button>
  );

  if (!isContinueButton) {
    return (
      <label className={styles.fullWidth} ref={clickTrackable}>
        {buttonElement}
      </label>
    );
  }

  return buttonElement;
}
